export default "__VITE_ASSET__D752O32p__"